import {html, type TemplateResult} from "lit";
import {customElement, property, state} from "lit/decorators.js";
import {LoadAfterConfirmationEvents} from "./loadAfterConfirmation";
import {resolve} from "../../container";
import {UnLitElement} from "../../common/elements";
import {classMap} from "lit/directives/class-map.js";

export enum EmbedAspectRatio {
    SIXTEEN_BY_NINE = "16by9",
    SEVEN_BY_FOUR = "7by4"
}

@customElement("eop-confirmable-iframe-element")
export class EopConfirmableIframeElement extends UnLitElement {

    @property({attribute: "aspect-ratio", reflect: true})
    public aspectRatio: EmbedAspectRatio = EmbedAspectRatio.SIXTEEN_BY_NINE;
    @property({attribute: "src"})
    private src: string;
    @property({attribute: "module-name"})
    private moduleName: string;
    @property({attribute: "frame-title"})
    private frameTitle: string;
    @property({attribute: "additionalClasses"})
    private additionalClasses: Record<string, boolean> = {};
    @state()
    private dynamicSrc: string;

    private confirmationAbortController: AbortController;

    public constructor(private loadAfterConfirmationEvents: LoadAfterConfirmationEvents = resolve(LoadAfterConfirmationEvents)) {
        super();
    }

    public connectedCallback(): void {
        super.connectedCallback();

        this.confirmationAbortController = this.loadAfterConfirmationEvents.onConfirmation(this.moduleName, async () => {
            this.dynamicSrc = this.src;
        });
    }

    public disconnectedCallback(): void {
        this.confirmationAbortController.abort();
        super.disconnectedCallback();
    }

    public render(): TemplateResult {
        return html`
            <div class="iframe-container ${classMap(this.additionalClasses)}">
                <iframe src=${this.dynamicSrc} title=${this.frameTitle} allow="fullscreen"></iframe>
            </div>
        `;
    }
}